import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csifelseif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free PHP If Else If Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php if else if tutorial for beginners.if else if in Php is used for making a decision. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php else if vs elseif,php if else one line,php if else if endif,tutorial for begineers,Php if else if,php if-else if,Php if else if for loop,end for loop Php,if else if foreach Php" />
 <link rel="canonical" href="https://www.codeexampler.com/php-if-else-if" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">If-else-if Statement in Php</h1>
    <div className="first">
        <a href="/php-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Php if-else if Syntax:
</h2>

 
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">condition</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-4">else </span>
            <span className="qwerty-5">if</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-4">else </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">Q-Write a program to Check maximum no between three no in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-3">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">ab </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">20</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">cd </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">40</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty">$</span>
            <span className="qwerty-7">ef </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">60</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-10">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">ab </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">cd </span>
            <span className="qwerty-4"> &&  </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">ab</span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">ef</span>
            <span className="qwerty-3">) </span>
              {"\n"}
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo</span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">ab</span>
              <span className="qwerty-2">"; </span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-10">else if</span>
              <span className="qwerty-3"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">cd </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">ab </span>
            <span className="qwerty-4"> &&  </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">cd</span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">ef</span>
            <span className="qwerty-3">) </span>
              {"\n"} 
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">cd</span>
              <span className="qwerty-2">"; </span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-10">else</span>
              {"\n"} 
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">ef</span>
              <span className="qwerty-2">"; </span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-3">?</span>
              <span className="qwerty-4">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-7">ef</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">Q-Write a program to Check no is positive, negative, zero in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-3">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">i </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">46</span>
            <span className="qwerty-3">; </span>
              {"\n"}
              <span className="qwerty-10">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">i</span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-4">0</span>
            <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo</span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">negative</span>
              <span className="qwerty-2">"; </span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-10">else </span>
              <span className="qwerty">if </span>
              <span className="qwerty-3"> (</span>
            <span className="qwerty">$</span>
            <span className="qwerty-7">i </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-4">0</span>
            <span className="qwerty-3">) </span>
              {"\n"} 
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">positive</span>
              <span className="qwerty-2">"; </span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-10">else</span>
              {"\n"} 
              <span className="qwerty-3"> &#123;</span>
              {"\n"} 
              <span className="qwerty-5">echo </span>
              <span className="qwerty-2">"</span>
                <span className="qwerty-7">zero</span>
              <span className="qwerty-2">"; </span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-3">?</span>
              <span className="qwerty-4">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-7">positive</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/php-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-switch">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csifelseif;